import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { CircularProgress, Typography, Button } from '@material-ui/core';
import CustomerReviews from './CustomerReviews';
import MonthlyReviewChart from './MonthlyReviewChart';
import MonthlyInsightsChart from './MonthlyInsightsChart';
import CompetitorModal from './CompetitorModal';

const styles = {
	root: {
		padding: '16px 24px',
		height: '100%',
		maxHeight: '90vh',
		display: 'flex',
		flexDirection: 'column',
		minWidth: 900,
		minHeight: 500,
	},
	loading: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		alignItems: 'center',
		height: '100%',
		minWidth: 900,
		minHeight: 500,
		padding: '16px 24px',
	},
	content: {
		display: 'flex',
		gap: 16,
		height: '100%',
		overflow: 'hidden',
	},
	column: {
		flex: 1,
		display: 'flex',
		flexDirection: 'column',
		gap: 16,
		maxHeight: '100%',
	},
	leftColumn: {
		flex: 1,
		display: 'flex',
		flexDirection: 'column',
		gap: 16,
		maxHeight: '100%',
		overflowY: 'auto',
	},
	rightColumn: {
		flex: 1,
		display: 'flex',
		flexDirection: 'column',
		gap: 16,
		maxHeight: '100%',
	},
	chart: {
		flex: 1,
		minHeight: 0,
	},
};

const ReviewDialogContent = ({ _enterpriseLocation }) => {
	const [state, setState] = useState({
		reviews: [],
		reviewsByMonth: [],
		insightsByMonth: [],
		loading: true,
		showCompetitorModalChart: false,
		error: null,
	});

	const fetchData = async () => {
		setState((prev) => ({ ...prev, loading: true, error: null }));

		let didTimeout = false;
		const timeout = setTimeout(() => {
			didTimeout = true;
			setState((prev) => ({
				...prev,
				loading: false,
				error: 'Loading reviews took too long. Please try again.',
			}));
		}, 15000);

		try {
			const res = await axios.post('/api/review-modal-data', {
				_enterpriseLocation,
			});

			if (!didTimeout) {
				clearTimeout(timeout);
				const { google } = res.data;
				if (google) {
					setState({
						reviews: google.reviews,
						reviewsByMonth: google.reviewsByMonth,
						insightsByMonth: google.insightsByMonth,
						loading: false,
						showCompetitorModalChart: false,
						error: null,
					});
				} else {
					setState((prev) => ({
						...prev,
						loading: false,
						error: 'No review data found.',
					}));
				}
			}
		} catch (err) {
			if (!didTimeout) {
				clearTimeout(timeout);
				setState((prev) => ({
					...prev,
					loading: false,
					error: 'There was an error loading reviews. Please try again.',
				}));
			}
		}
	};

	useEffect(() => {
		fetchData();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [_enterpriseLocation]);

	const handleClose = () => {
		setState((prev) => ({ ...prev, showCompetitorModalChart: false }));
	};

	const handleRetry = () => {
		fetchData();
	};

	if (state.loading) {
		return (
			<div style={styles.loading}>
				<Typography
					variant='h6'
					style={{
						marginBottom: 24,
						fontWeight: 600,
						fontSize: '1.25rem',
						color: '#22223b',
					}}
				>
					Loading Reviews
				</Typography>
				<CircularProgress color='secondary' />
			</div>
		);
	}

	if (state.error) {
		return (
			<div style={styles.loading}>
				<Typography
					variant='h6'
					style={{
						marginBottom: 24,
						fontWeight: 600,
						fontSize: '1.1rem',
						color: '#b91c1c',
					}}
				>
					{state.error}
				</Typography>
				<Button
					variant='contained'
					color='secondary'
					onClick={handleRetry}
					style={{ marginTop: 8 }}
				>
					Retry
				</Button>
			</div>
		);
	}

	return (
		<div style={styles.root}>
			<div
				style={{
					...styles.content,
					flexDirection: window.innerWidth <= 600 ? 'column' : 'row',
				}}
			>
				<div style={styles.leftColumn}>
					<CustomerReviews reviews={state.reviews} />
				</div>
				<div style={styles.rightColumn}>
					<div style={styles.chart}>
						<MonthlyReviewChart
							reviewsByMonth={state.reviewsByMonth}
						/>
					</div>
					<div style={styles.chart}>
						<MonthlyInsightsChart
							insightsByMonth={state.insightsByMonth}
						/>
					</div>
				</div>
			</div>
			<CompetitorModal
				open={state.showCompetitorModalChart}
				onClose={handleClose}
				_enterpriseLocation={_enterpriseLocation}
			/>
		</div>
	);
};

export default ReviewDialogContent;



// WEBPACK FOOTER //
// ./src/components/review/ReviewTable/Modal/ReviewModalContent.js